import React, { useState } from 'react';
import PropTypes from 'prop-types';

const MessageInput = ({
  conversationMode,
  conversationStarted,
  loading = false,
  onSendMessage,
  placeholder = "Type your answer..."
}) => {
  const [userMessage, setUserMessage] = useState("");

  const handleSendMessage = async () => {
    if (!userMessage.trim() || loading) return;
    
    const messageToSend = userMessage;
    setUserMessage(""); // Clear input immediately
    
    try {
      await onSendMessage(messageToSend);
    } catch (error) {
      console.error("Error sending message:", error);
      // Don't restore the message on error - keep it cleared
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  // Only show text input for text and voiceText modes when conversation is started
  if (!conversationStarted || (conversationMode !== "text" && conversationMode !== "voiceText")) {
    return null;
  }

  return (
    <div className="text-input-container" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
      <input
        type="text"
        className="input-field"
        value={userMessage}
        onChange={(e) => setUserMessage(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={loading}
      />
      {conversationMode === "text" && (
        <button 
          className="btn btn--small" 
          onClick={handleSendMessage}
          disabled={loading || !userMessage.trim()}
        >
          Submit
        </button>
      )}
    </div>
  );
};

MessageInput.propTypes = {
  conversationMode: PropTypes.oneOf(['text', 'voice', 'voiceText']).isRequired,
  conversationStarted: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  onSendMessage: PropTypes.func.isRequired,
  placeholder: PropTypes.string
};

export default MessageInput;